import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { CircleNotch } from "@phosphor-icons/react";

export function ProtectedRoute({ children, roles }) {
  const { user } = useAuth();

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="auth-loading">
        <CircleNotch size={40} className="animate-spin text-[#FF5A36]" />
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) {
    const home = user.role === "ADMIN" ? "/app/admin" : user.role === "CARRIER" ? "/app/carrier" : "/app/client";
    return <Navigate to={home} replace />;
  }
  return children;
}

export function roleHome(role) {
  return role === "ADMIN" ? "/app/admin" : role === "CARRIER" ? "/app/carrier" : "/app/client";
}
